import React from 'react';
import { db } from './Firebase/firebase';
import { useState } from 'react';

import loading_gif from './assets/loading.gif';
import logo from './assets/usku_logo.png';
import './business.css';

function Business() {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formState, setFormState] = useState({});
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [customerDetails, setCustomerDetails] = useState(null);
    const [invoices, setInvoices] = useState([]);

    function handleChange(e) {
        e.persist();
        setFormState(formState => ({...formState, [e.target.name]: e.target.value}))
    }

    async function handleSubmit(e) {
        setLoading(true);
        console.log('Submit button clicked');
        e.persist();
        const { email, phone } = formState;

        try {
            await db.collection('customers').doc(email)
                .get()
                .then((doc) => {
                    const data = doc.data();
                    data['email'] = doc.id;

                    const isOwner = validateOwner(phone, data);
                    if (isOwner) {
                        setCustomerDetails(data);
                        setFormSubmitted(true);
                        setError("");
                        getInvoices(data['stripe_id']);
                    } else {
                        setError("Name and order mismatch");
                    }

                    setLoading(false);
                })
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    }

    function getInvoices(stripe_id) {
        const url = 'https://usku-delivery-server.herokuapp.com/businessInvoices' 

        console.log(stripe_id);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ stripe_id: stripe_id })
        };

        fetch(url, requestOptions).then((response) => response.json())
            .then((data) => {
                setInvoices(data['invoices']);
            }
        )
    }

    function validateOwner(phone, metadata) {

        if (phone.toLowerCase() === metadata.phone.toLowerCase()) {
            return true;
        }
        return false;
    }

    function convertTimestamp(seconds) {
        const d = new Date(seconds * 1000);
        console.log(d);
        return d.toString().substr(0,24);
    }

    if (loading) {
        return(<img src={loading_gif}/>)
    } else if (!formSubmitted) {
        return (
            <div>
                <div className="form">
                    <div className="form-container">
                    <img className="usku-logo" src={logo} alt="Usku" />
                    <h1>Business Page Login</h1>
                    <div className="input-container">
                        <label htmlFor="email">Registered Email</label>
                        <input type="text" onChange={handleChange} name="email" id="email"/>
                    </div>
                    <div className="input-container">
                        <label htmlFor="phone">Registered Phone Number</label>
                        <input type="text" onChange={handleChange} id="phone" name="phone"/>
                    </div>
                    {error === null ? <p></p> : <p style={{textAlign: "center", color: "red"}}>{error}</p>}
                    <button className="btn" style={{textAlign: "center"}} onClick={handleSubmit}>Login</button>
                    </div>
                </div>
            </div>
        )
    } else if (formSubmitted) {
        return (
            <div className="form-container">
                <img className="usku-logo" src={logo} alt="Usku" />
                <h1>{customerDetails.name}</h1>
                <p>{customerDetails.phone}</p>
                <div>
                    <table style={{width: "80vw", margin: "16px"}}>
                        <tr>
                            <th>Created At</th>
                            <th>Invoice No.</th>
                            <th>Subtotal</th>
                            <th>Status</th>
                        </tr>
                        {invoices.length === 0 && <p>Fetching Data...</p>}
                        {invoices.length > 0 && console.log(invoices)}
                        {invoices.length > 0 && invoices.map((invoice) => {
                            return (
                            <tr>
                                <td>{convertTimestamp(invoice.created)}</td>
                                <td><a href={invoice.hosted_invoice_url} target="_blank">{invoice.number}</a></td>
                                <td>$ {(invoice.total)/100}</td>
                                <td>{invoice.status}</td>
                            </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
        )
    }

    
}

export default Business;